// Appdevfuture.jsx
import React, { useEffect, useRef, useState } from "react";
import "../Style/appdevfuture.css";

import cimage from "../assets/A.png";
import fimage from "../assets/C.png";
import bimage from "../assets/C.png";
import mimage from "../assets/M.png";
import pimage from "../assets/S.png";

const services = [
  {
    id: 1,
    icon: cimage,
    alt: "AI-Enabled Mobile Applications",
    title: "AI-Powered Applications",
    text: "Build intelligent mobile apps powered by artificial intelligence, automation, and predictive features to deliver smarter user experiences and business efficiency.",
    row: "top",
  },
  {
    id: 2,
    icon: fimage,
    alt: "Cross-Platform App Development",
    title: "Cross-Platform App Development",
    text: "Develop Android and iOS applications from a single codebase using modern frameworks that reduce development time without compromising performance.",
    row: "top",
  },
  {
    id: 3,
    icon: bimage,
    alt: "Cloud-Native Mobile Architecture",
    title: "Cloud-Native Mobile Architecture",
    text: "Design scalable cloud-connected mobile applications that offer high availability, real-time synchronization, and secure data management.",
    row: "top",
  },
];

const Appdevfuture = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.12 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className={`appdevfuture-main-section ${isVisible ? "appdevfuture-visible" : ""}`}
      ref={sectionRef}
    >
      <div className="appdevfuture-glow appdevfuture-glow-1" aria-hidden="true" />
      <div className="appdevfuture-glow appdevfuture-glow-2" aria-hidden="true" />

      <div className="appdevfuture-main-container">
        <span className="appdevfuture-eyebrow appdevfuture-anim appdevfuture-anim-0">
          Our Approach
        </span>

        {/* Heading */}
        <h1 className="appdevfuture-main-title appdevfuture-anim appdevfuture-anim-1">
          Future-Ready Mobile App Development Solutions
        </h1>

        {/* Delivered by */}
        <p className="appdevfuture-subtitle-label appdevfuture-anim appdevfuture-anim-2">
          Delivered by MPeoples
        </p>

        {/* Description */}
        <p className="appdevfuture-main-description appdevfuture-anim appdevfuture-anim-3">
          At MPeoples, we build scalable, secure, and high-performance mobile
          applications that help businesses streamline operations, engage
          customers, and accelerate digital growth. Our development approach
          combines modern technologies, intuitive design, and robust
          architecture to create apps that are built for long-term success.
        </p>

        {/* Cards Grid */}
        <div className="appdevfuture-card-grid">
          {/* Top row — 3 cards */}
          {services
            .filter((s) => s.row === "top")
            .map((service, i) => (
              <div
                key={service.id}
                className={`appdevfuture-service-card appdevfuture-anim appdevfuture-anim-${4 + i}`}
              >
                <div className="appdevfuture-card-header">
                  <div className="appdevfuture-card-icon-wrap">
                    <img
                      src={service.icon}
                      alt={service.alt}
                      className="appdevfuture-card-icon"
                    />
                  </div>
                  <h3 className="appdevfuture-card-title">{service.title}</h3>
                </div>
                <p className="appdevfuture-card-text">{service.text}</p>
              </div>
            ))}

          {/* Bottom row — 2 cards */}
          <div className="appdevfuture-service-card appdevfuture-card-bottom-left appdevfuture-anim appdevfuture-anim-7">
            <div className="appdevfuture-card-header">
              <div className="appdevfuture-card-icon-wrap">
                <img
                  src={mimage}
                  alt="Enterprise-Grade App Security"
                  className="appdevfuture-card-icon"
                />
              </div>
              <h3 className="appdevfuture-card-title">Enhanced App Security</h3>
            </div>
            <p className="appdevfuture-card-text">
              Protect sensitive business and customer data with secure
              authentication, encrypted communication, and industry-standard
              security practices.
            </p>
          </div>

          <div className="appdevfuture-service-card appdevfuture-card-bottom-right appdevfuture-anim appdevfuture-anim-8">
            <div className="appdevfuture-card-header">
              <div className="appdevfuture-card-icon-wrap">
                <img
                  src={pimage}
                  alt="Exceptional Mobile User Experience"
                  className="appdevfuture-card-icon"
                />
              </div>
              <h3 className="appdevfuture-card-title">
                Seamless User Experiences
              </h3>
            </div>
            <p className="appdevfuture-card-text">
              Create intuitive interfaces, smooth navigation, and responsive
              interactions that improve engagement, usability, and customer
              satisfaction.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Appdevfuture;